import { Select, SelectItem } from "@/components/ui/select";

/* Prop Types */
interface SelectSortProps {
  setOrderBy: (value: "name" | "updatedAt") => void;
  setSortBy: (value: "asc" | "desc") => void;
}

/*
 * SelectSort component
 *
 * Component to sort details such as projects, contexts, etc.
 */
export const SelectSort = ({ setOrderBy, setSortBy }: SelectSortProps) => {
  /* Handlers */
  const handleOnChange = (value: string) => {
    switch (value) {
      case "mostRecent":
        setOrderBy("updatedAt");
        setSortBy("desc");
        break;
      case "oldestFirst":
        setOrderBy("updatedAt");
        setSortBy("asc");
        break;
      case "A-ZOrder":
        setOrderBy("name");
        setSortBy("asc");
        break;
      case "Z-AOrder":
        setOrderBy("name");
        setSortBy("desc");
        break;
      default:
        break;
    }
  };

  /* Render */
  return (
    <Select onChange={handleOnChange}>
      <SelectItem value="mostRecent">Most recent</SelectItem>
      <SelectItem value="oldestFirst">Oldest first</SelectItem>
      <SelectItem value="A-ZOrder">A-Z order</SelectItem>
      <SelectItem value="Z-AOrder">Z-A order</SelectItem>
    </Select>
  );
};
